const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the pie chart component
 * @argument {Application} Application the service defined to manage Application specific tools and functions
 */

app.directive('froalaViewer', ['$location', '$translate', function ($location, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      content: '=',
      lightboxStatus: '=?',
      lightboxUrl: '=?'
    },
    template: require('../../templates/directives/froala-viewer.html'),
    link: function (scope, element, attrs) {
        var self = this;
        scope.newContent = '';
        self.isLoaded = 'false';

        self.addTableClicks = function () {
          var triggers = document.querySelectorAll('.fv-expandRow');
          if (triggers && triggers.length) {
            for (var i = 0; i < triggers.length; i++) {
              triggers[i].addEventListener('click', function(e) {
                var originalTable = e.target.parentNode.parentNode.parentNode;
                if (originalTable.classList.contains('fv-expandTable')) {
                  var viewWindow = document.querySelector('.tableViewer');
                  viewWindow.innerHTML = '<span class="tableViewer__close"><i class="ui huge close icon"></i></span>' + originalTable.outerHTML;
                  viewWindow.querySelector('.tableViewer__close').addEventListener('click', function (e) {
                    viewWindow.classList.remove('tableViewer--active');
                  })
                  viewWindow.classList.add('tableViewer--active');
                  e.preventDefault();
                };
              });
            };
          };
        };

        function init(input){

          var viewer = document.createElement('div');
          viewer.innerHTML = input;

          self.contentImages = viewer.querySelectorAll('img');
          for(var i = 0; i < self.contentImages.length; i++){
            self.contentImages[i].classList.add('lightboxImage');
          };

          self.allContents = viewer.children;
          for (var u = 0; u < self.allContents.length; u++){
            if (self.allContents[u].tagName === "TABLE" && self.allContents[u].parentNode.nodeName === "DIV"){
              var expandRow = document.createElement('tr');
              expandRow.classList.add('fv-expandRow');
              var count = self.allContents[u].rows[0].cells.length;
              expandRow.innerHTML = "<td colspan='" + count + "'><span class='simpletip'><i class='ui white expand icon'></i><span class='simpletip__tip'>" + self.translationsData['froalaviewer.expandTable'] + "</span></span></td>";    
              self.allContents[u].classList.add('fv-expandTable');
              var theFirstChild =  self.allContents[u].firstChild;
              self.allContents[u].insertBefore(expandRow, theFirstChild);
            }
          };
          
          if (self.allContents && self.allContents.length) {
            var tableViewer = document.createElement('div');
            tableViewer.classList.add('tableViewer');
            tableViewer.innerHTML = '<span class="tableViewer__close"><i class="ui large close icon"></i><span>';
            viewer.appendChild(tableViewer);
          };

          var lastItem = viewer.querySelector('p:last-child');
          if (lastItem && lastItem.innerHTML === '<br>') {
            lastItem.parentNode.removeChild(lastItem);
          }

          scope.newContent = viewer.innerHTML;

          setTimeout(function(){

            self.renderedImages = document.querySelectorAll('.lightboxImage');
            for(var i = 0; i < self.renderedImages.length; i++){
              self.renderedImages[i].addEventListener("click", function(e){
                var imageSrc = this.src;
                scope.$apply(function () {
                  scope.lightboxStatus = 'enabled';
                  scope.lightboxUrl = imageSrc;
                });
              });
              window.testElement = self.renderedImages[i];
            };

            self.loadToHash = function(){
              var currentHash = $location.hash();
              var casedHash = currentHash.toLowerCase();
              if (currentHash){
                var interval = setInterval(function() {
                  if(document.readyState === 'complete') {
                    clearInterval(interval);
                    setTimeout(function(){
                      if (document.querySelector('#' + casedHash)){
                        var targetElm = document.querySelector('#' + casedHash);
                        self.onFullLoad(function () {
                          self.scrollToLocation(targetElm.offsetTop, 100);
                        });
                      } else {
                        var headers = document.querySelectorAll('.contentview__content .fr-view h1, .contentview__content .fr-view h2, .contentview__content .fr-view h3, .contentview__content .fr-view h4');
                        if (headers.length) {
                          for (var i = 0; i < headers.length; i++ ) {
                            var strippedText = headers[i].innerHTML.toLowerCase().replace(/<[^>]*>?/gm, '').replace(/ /g, '').replace(/\&nbsp\;/gm, '');
                            if (strippedText === casedHash) {
                              self.onFullLoad(function () {
                                self.scrollToLocation(headers[i].offsetTop, 100);
                              });
                              break;
                            }
                          }
                        }
                      }
                    },2000);
                  }
                }, 100);
              };
            };

            self.getOffsetTop = function(selector){
              var offset = 0;
              if (selector){
                var elementToGet = document.querySelector(selector);
                offset = elementToGet.offsetTop;
                return offset;
              }
              return offset;
            };
            
            var escapeChars = function(string){
              var newstring = string.replace(/[\!\@\$\%\&\*\(\)]/gi,function(x){
              return ('\\' + x);
              });
              return newstring;
            };

            self.attachLocalJumps = function(){
              var anchorLinks = document.querySelectorAll('.contentview__content .fr-view a[href^="#"]');
              if (anchorLinks.length){
                for (var i = 0 ; i < anchorLinks.length; i++){
                  var localAnchor = anchorLinks[i];
                  var casedHash = localAnchor.hash.toLowerCase();
                  var elmMatch = document.querySelector(escapeChars(casedHash));
                  if( elmMatch ){
                    anchorLinks[i].addEventListener('click', function(e){
                      e.preventDefault();
                      var thisHash = e.currentTarget.hash;
                      self.scrollToLocation(
                        self.getOffsetTop('.contentview__content .fr-view ' + thisHash ),
                        100
                      );
                    });
                  } else {
                    anchorLinks[i].addEventListener('click', function(e){
                      var clickedHash = e.currentTarget.hash ? e.currentTarget.hash : '';
                      var headers = document.querySelectorAll('.contentview__content .fr-view h1, .contentview__content .fr-view h2, .contentview__content .fr-view h3, .contentview__content .fr-view h4');
                      if (headers.length) {
                        for (var iter = 0; iter < headers.length; iter++) {
                          var elmValue = headers[iter].innerHTML.toLowerCase()
                          .replace(/\s/g, '')
                          .replace(/<[^>]*>?/gm, '')
                          .replace(/\&nbsp\;/gm, '')
                          .replace('&#33;','!')
                          .replace('&#64;','@')
                          .replace('&#36;','$')
                          .replace('&#37;','%')
                          .replace('&amp;','&')
                          .replace('&#38;','&')
                          .replace('&#42;','*')
                          .replace('&#40;','(')
                          .replace('&#41;',')');
                          if ( elmValue === clickedHash.toLowerCase().replace(/\#/g,'')) {
                            var temp = function (iter) {
                              self.scrollToLocation(headers[iter].offsetTop, 100);
                            };
                            temp(iter);
                          }
                        }
                      };
                      e.preventDefault();
                    });
                  };
                };
              }
            };

            self.scrollToLocation = function (location, offset) {
              if (typeof location === "number" && typeof offset === "number") {
                var scrollElm = document.querySelector('.edit__maincontent--preview');
                var targetLocation = (location - offset);
                function step() {
                  if(scrollElm){
                    scrollElm.scrollTo({
                      top: targetLocation,
                      left: 0,
                      behavior: 'smooth'
                    } )
                  } else {
                    window.scrollTo({
                      top: targetLocation,
                      left: 0,
                      behavior: 'smooth'
                    });
                  }
                }
                window.requestAnimationFrame(step);
              }
            };

            self.onFullLoad = function(whenLoaded){
              angular.element(document).ready(function () {
                whenLoaded();
              });
            };

            var currentlocation = $location.path();
            if (!currentlocation.match(/edit/)){
              // view page
              self.loadToHash();
              self.onFullLoad(self.attachLocalJumps);
              self.addTableClicks();
            } else {
              // Edit page
              self.onFullLoad(self.attachLocalJumps);
              self.addTableClicks();
              document.querySelector('.fr-view').setAttribute('data-gramm', 'false');
            };

          }, 10);
          
          self.isLoaded = 'true';
        };
      
        $translate(['froalaviewer.expandTable']).then(function(translations) {
          self.translationsData = translations;
          if (scope.content) {
            init(scope.content);          
          };
        });

        scope.$watch("content", function (input) {
          if (input){
            init(input);
          };
        });
      
    }
  };
}]);
